import { Button } from '@aqarmap/aqarmap-ui';
import { useTranslation } from 'react-i18next';
import Modal from '~/components/Modal';
import { formatNumber } from '~/lib';
import { closeModal } from '~/redux/features/uiState/uiStateSlice';
import { useAppDispatch } from '~/redux/hooks';
import { ListingFeatureType } from '~/types/featureListingTypes';

export default function FeatureConfirmModal({
  feature,
  isLoading,
  onConfirm,
}: {
  feature: ListingFeatureType | null;
  isLoading: boolean;
  onConfirm: () => void;
}) {
  const { t } = useTranslation('app');
  const dispatch = useAppDispatch();

  return (
    <Modal
      modalKey="featureListingConfirmModal"
      title={t('featureListingPageTitle')}
      Footer={
        <div className="flex w-full gap-x">
          <Button
            ariaLabel="confirm-feature-listing"
            size="medium"
            variant="primary"
            className="w-full"
            isLoading={isLoading}
            disabled={isLoading}
            onClick={onConfirm}
          >
            {t('featureConfirmAction')}
          </Button>
          <Button
            ariaLabel="cancel-feature-listing"
            size="medium"
            variant="secondary"
            className="w-full"
            disabled={isLoading}
            onClick={() => {
              dispatch(closeModal('featureListingConfirmModal'));
            }}
          >
            {t('cancel')}
          </Button>
        </div>
      }
      bodyClassName="!pt-2x"
    >
      <div className="flex flex-col gap-1.5x">
        <p className="text-title-4 text-gray__dark_2">
          {t('featureConfirmQuestion', { name: feature?.title })}
        </p>
        <p className="text-body-1 text-gray__dark_2">
          {t('featureConfirmDescription', {
            credit: formatNumber(feature?.fees ?? 0),
            days: feature?.duration ?? 0,
          })}
        </p>
      </div>
    </Modal>
  );
}
